(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-seen-also-available"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  new Swiper('.asSeenSlider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 10,
    speed: 1000,
    autoplay: false,
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      window._customVariantSwiper = new Swiper('.custom-variant-images', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 0,
        speed: 1000,
        autoplay: false,
        navigation: { nextEl: '.custom-variant-images .swiper-button-next', prevEl: '.custom-variant-images .swiper-button-prev' },
      }); 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-saalt-window-display"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 767) {
    new Swiper('.custom-window-wrap', {
      slidesPerView: 2.65,
      loop: true,
      spaceBetween: 10,
      speed: 1000,
      autoplay: false,
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-faq"] && !Shopify.designMode) return;
  try {
    
  const items = document.querySelectorAll('.accordion button');
  function toggleAccordion() {
    const itemToggle = this.getAttribute('aria-expanded');

    for (i = 0; i < items.length; i++) {
      items[i].setAttribute('aria-expanded', 'false');
    }

    if (itemToggle == 'false') {
      this.setAttribute('aria-expanded', 'true');
    }
  }
  items.forEach((item) => item.addEventListener('click', toggleAccordion));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  const items = document.querySelectorAll('.accordion button');
  function toggleAccordion() {
    const itemToggle = this.getAttribute('aria-expanded');

    for (i = 0; i < items.length; i++) {
      items[i].setAttribute('aria-expanded', 'false');
    }

    if (itemToggle == 'false') {
      this.setAttribute('aria-expanded', 'true');
    }
  }
  items.forEach((item) => item.addEventListener('click', toggleAccordion));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    function updateSlideAria(swiper) {
      swiper.slides.forEach(function(slide) {
        slide.setAttribute('aria-hidden', 'true');

        slide.querySelectorAll('a, button, input, textarea, select, [tabindex]').forEach(function(el) {
          el.setAttribute('tabindex', '-1');
        });
      });

      var activeSlide = swiper.slides[swiper.activeIndex];

      if (activeSlide) {
        activeSlide.setAttribute('aria-hidden', 'false');

        activeSlide.querySelectorAll('a, button, input, textarea, select').forEach(function(el) {
          el.removeAttribute('tabindex');
        });
      }
    }

    var heroSwiper = new Swiper('.hero-slider', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 20,
      speed: 600,
      autoplay: false,

      navigation: {
        nextEl: '.hero-slider .swiper-button-next',
        prevEl: '.hero-slider .swiper-button-prev'
      },

      pagination: {
        el: '.hero-slider .swiper-pagination',
        clickable: true
      },

      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      },

      on: {
        init: function(swiper) {
          updateSlideAria(swiper);

          document.querySelectorAll('.hero-slider .swiper-pagination-bullet').forEach(function(dot, i) {
            dot.setAttribute('aria-label', 'Go to slide ' + (
              i + 1
            ));
          });

          const nextBtn = document.querySelector('.hero-slider .swiper-button-next');
          const prevBtn = document.querySelector('.hero-slider .swiper-button-prev');

          if (nextBtn) 
            nextBtn.setAttribute('aria-label', 'Next slide');
          
          if (prevBtn) 
            prevBtn.setAttribute('aria-label', 'Previous slide');
          
        },

        slideChangeTransitionEnd: function(swiper) {
          updateSlideAria(swiper);
        }
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-review"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  new Swiper('.home-review', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    speed: 1000,
    autoplay: false,
    navigation: {
      nextEl: '.home-review-next',
      prevEl: '.home-review-prev',
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 641) {
    document.querySelector('.swiper').setAttribute('dir','rtl');
    new Swiper('#review-card', {
      slidesPerView: 1.5,
      // centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      speed: 1000,
      autoplay: false,
      navigation: {
        nextEl: '#review-card .swiper-button-next',
        prevEl: '#review-card .swiper-button-prev',
      },
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["take-our-word"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 1200) {
    new Swiper('.take-word-slider', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 20,
      speed: 1000,
      autoplay: false,
      navigation: {
        nextEl: '.take-word-slider .swiper-button-next',
        prevEl: '.take-word-slider .swiper-button-prev',
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        900: { slidesPerView: 3 },
      },
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 1200) {
    new Swiper('.testimonial-slider', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 20,
      speed: 1000,
      autoplay: false,
      navigation: {
        nextEl: '.testimonial-slider .swiper-button-next',
        prevEl: '.testimonial-slider .swiper-button-prev',
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        900: { slidesPerView: 3 },
      },
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-box"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 1000) {
    new Swiper('.three-icon-box', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 20,
      speed: 1000,
      autoplay: { delay: 9000, disableOnInteraction: false },
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-to-fifty-off"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 767) {
    new Swiper('.upToFiftyOff', {
      slidesPerView: 1.55,
      loop: true,
      spaceBetween: 15,
      speed: 1000,
      autoplay: false,
      breakpoints: {
        575: { slidesPerView: 2.5 },
      },
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-section"] && !Shopify.designMode) return;
  try {
    
var swiperVideoInstances = [];

function swiperVideoPause(vid) {
  swiperVideoInstances.forEach(function(swiper){
    if (swiper.autoplay) swiper.autoplay.stop();
  });
}

function swiperVideoPlay(vid) {
  swiperVideoInstances.forEach(function(swiper){
    if (swiper.autoplay) swiper.autoplay.start();
  });
}

document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.video-holder').forEach(function(el){

    var swiper = new Swiper(el, {
      direction: 'horizontal',
      slidesPerView: 1.4,
      centeredSlides: true,
      loop: false,
      spaceBetween: 10,
      speed: 1000,
      autoplay: false,
      draggable: true, 
      allowTouchMove: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      autoHeight: false,


     

      breakpoints: {
        640: {
          slidesPerView: 1.7,
          spaceBetween: 10,
          centeredSlides: false
        },
        1000: {
          slidesPerView: 2.7,
          spaceBetween: 20,
          centeredSlides: false
        }
      }
    });

    swiperVideoInstances.push(swiper);

  });

});


  } catch(e) { console.error(e); }
})();
})();
